import { withTranslation } from "next-i18next";
import NextImage from "next/image";
import Link from "@components/core/Link";
import ImgixLoader from "@utils/images/ImgixLoader";
import closetStates from "@utils/constants/closetStates";
import translateVariantSize from "@utils/translateVariantSize";
import ProductPrice from "./ProductPrice";
import ClosetItemButtons from "./ClosetItemButtons";

function ClosetItem({
  closetState,
  closetItem,
  closetHasMailboxPickingRequested,
  fromDrawer,
  t,
}) {
  const product = closetItem?.product || {};

  return (
    <div className="w-100 bg-white">
      <div className="closet-items-list-card-content">
        <div className="picture-section bg-light">
          <Link
            href={`/products/${product.slug}`}
            className="w-100"
          >
            <NextImage
              loader={ImgixLoader}
              src={product.main_picture_url}
              alt={product.name}
              className="w-100"
              fill
              sizes="192px"
            />
          </Link>
        </div>

        <div className="description-section">
          <div className="d-flex flex-column gap-1 mb-2 w-100">
            <h6 className="mb-0 drawer-closet-item-name">
              {product.name}
            </h6>

            <p className="mb-0 font-size-sm text-gray drawer-closet-item-name">
              {product.brand.name}
            </p>

            <p className="mb-0 font-size-sm text-gray">
              {t("common:variant_size", { size: translateVariantSize(closetItem.variant.size?.type, closetItem.variant.size?.value, t) })}
            </p>
          </div>

          {closetState === closetStates.received && !closetHasMailboxPickingRequested && !closetItem.purchased && !closetItem.purchasing && (
            <ProductPrice product={product} />
          )}
          {closetItem.purchased && (
            <p className="mb-0 font-size-sm text-gray">
              {t("common:drawer.card.bought")}
            </p>
          )}
          {closetItem.purchasing && (
            <p className="mb-0 font-size-sm text-gray">
              {t("common:drawer.card.purchasing")}
            </p>
          )}
        </div>
      </div>

      <ClosetItemButtons
        closetState={closetState}
        closetItem={closetItem}
        closetHasMailboxPickingRequested={closetHasMailboxPickingRequested}
        fromDrawer={fromDrawer}
      />
    </div>
  );
}

export default withTranslation("common")(ClosetItem);
